import React from 'react';
import styled, { css } from 'styled-components';
import { switchProp, theme, palette, ifProp } from 'styled-tools';

export type TitleProperties = {
  size: 'lg' | 'md' | 'sm';
} & React.HtmlHTMLAttributes<HTMLHeadingElement>;

export const Title = styled.h2<TitleProperties>`
  margin: 0;
  color: ${palette('asphalt')};
  text-align: ${ifProp('center', 'center', 'left')};
  ${theme('components.Title.default')}

  ${switchProp('size', {
    lg: css`
      font-size: ${theme('fontSize.xl')};
      line-height: 100%;
      font-weight: ${theme('fontWeight.bold')};
      ${theme('components.Title.sizes.lg')}
    `,
    md: css`
      font-size: ${theme('fontSize.lg')};
      line-height: 100%;
      font-weight: ${theme('fontWeight.bold')};
      ${theme('components.Title.sizes.md')}
    `,
    sm: css`
      font-size: ${theme('fontSize.md')};
      line-height: 26px;
      font-weight: ${theme('fontWeight.bold')};
      ${theme('components.Title.sizes.sm')}
    `,
  })}
`;
